
export const ErrorPage = (props) => {
    
    return (
        <div className="page-container">
            <p className="message__container message__container--centered">
                <span className="message__text">
                    Ocorreu um erro inesperado.
                </span>
                <span className="message__text">
                    Contate suporte.caas@qitech.com.br
                </span>
            </p>
        </div>
    )
}